import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { TemplateModule } from './template/template.module';
import { TemplateService } from './shared/services/template.service';

// Layout Component
import { CommonLayoutComponent } from './common/common-layout.component';
//import 'angular-2-daterangepicker';
import * as $ from 'jquery';

// Routing Module
import { AppRoutes } from './app.routing';
// App Component
import { AppComponent } from './app.component';
import { DatePipe, DecimalPipe, CurrencyPipe } from '@angular/common';
import { ApplicationPipesModule } from './shared/application-pipes.module';
import { RestangularModule, Restangular } from 'ngx-restangular';
import { environment } from 'src/environments/environment';
import { SettingsService } from './shared/services/settings.service';
import { HomeComponent } from './home/home.component';

// Function for setting the default restangular configuration
export function RestangularConfigFactory(RestangularProvider, SettingsService) {
  RestangularProvider.setBaseUrl(environment.baseApiUrl);
  RestangularProvider.setDefaultHeaders({
    auth_key: '',
    dco_site_id: '1',
    datatype: '1',
  });
  // by each request to the server receive a token and update headers with it
  RestangularProvider.addFullRequestInterceptor(
    (element, operation, path, url, headers, params) => {
      let authKey = SettingsService.get().authKey;
      let apiKey = SettingsService.get().apiKey;
      console.log('in interceptor: authKey: %s | apiKey:%s ', authKey, apiKey);
      return {
        headers: Object.assign({}, headers, {
          auth_key: `${authKey}`,
          api_key: `${apiKey}`,
        }),
      };
    },
  );
}

@NgModule({
  imports: [
    BrowserModule,
    //RouterModule.forRoot(),
    RouterModule.forRoot(AppRoutes, {
      useHash: true,
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    }),
    SharedModule,
    TemplateModule,
    ApplicationPipesModule,
    RestangularModule.forRoot([SettingsService], RestangularConfigFactory),
  ],
  declarations: [AppComponent, CommonLayoutComponent, HomeComponent],
  providers: [
    TemplateService,
    DecimalPipe,
    DatePipe,
    CurrencyPipe,
    SettingsService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
